import React, { useState, useEffect } from "react";
import uid from "../../utils/uid";
import "./Toggle.css";
import withTheme from "../../hocs/withTheme";

function Toggle(props) {
    const {
        id = null,
        defaultChecked = false,
        disabled = false,
        error = false,
        onChange = () => {},
        value = props.defaultChecked,
        ...rest
    } = props;
    const toggleId = id || uid("toggle");
    const [tempChecked, setTempChecked] = useState(defaultChecked);
    const handleChange = ({ target: { checked: isChecked = false } = {} }) => {
        onChange(isChecked);
        setTempChecked(isChecked);
    };

    const onPressEnter = (event) => {
        if (event.which === 13 || event.keyCode === 13) {
            setTempChecked(!tempChecked);
            onChange(!tempChecked);
        }
    };

    useEffect(() => {
        setTempChecked(value);
    }, [value]);

    return (
        <div className={`Toggle ${error ? "toggle-error" : ""}`}>
            <input
                {...rest}
                id={toggleId}
                className="switch switch-round"
                type="checkbox"
                onChange={handleChange}
                checked={tempChecked}
                disabled={disabled}
            />
            {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
            <label
                role="switch"
                aria-checked={tempChecked}
                htmlFor={toggleId}
                onKeyPress={onPressEnter}
                tabIndex={disabled ? -1 : 0}
            />
        </div>
    );
}


export default withTheme(Toggle);
